var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"href":"/admin/new_login_info","variant":"primary"}},[_vm._v("ログイン情報発行")])}
var staticRenderFns = []

export { render, staticRenderFns }